import React from "react";


const Html = ({ data, cab, hijos, campokey, indiceData, id_elemento })=>{
    return <div id={id_elemento}  dangerouslySetInnerHTML={{__html: data[campokey]}}></div>
}


export default Html